import Btn from "../utils/btn";

const func = ($target) => {
	
	var $form = $target.find('[data-id="updateCartForm"]'),
		$addedToBasket = $('[data-id="addedToBasket"]'),
		$miniCartSummary = $('[data-id="miniCartSummary"]'),
		$price = $target.find('[data-id="price"]'),
		$itemQty = $target.find('[data-id="quantity"]'),
		$name = $target.find('[data-id="name"]'),
		$basketImage = $target.find('[data-id="basket-image"]'),
		$totalPrice = $target.find('[data-id="total-price"]'),
		$totalQty = $target.find('[data-id="total-qty"]'),
		$headerBasket = $('[data-target="#basket-slideout"]'),
		$basketSlideout = $("#basket-slideout"),
		headerHeight = $('[data-kd-id="header"]').outerHeight(),
		pageHeader = $(".page-header").outerHeight(),
		totalHeaderHeight =
			(headerHeight ? headerHeight : 0) + (pageHeader ? pageHeader : 0);

	$(document).on('click','.add-basket-btn', function(){
		var $this = $(this),
			$submitBtn = $this.find('button[type="submit"]'),
			$purchasableId = $this.find('input[name="purchasableId"]').val(),
			$qty = $this.find('input[name="qty"]').val(),
			$image = $this.data("image");

		$this.addClass('btn-animate');

		setTimeout(() => {
			$this.removeClass('btn-animate');
		}, 2000);

		$.ajax({
			type: "POST",
			dataType: "json",
			url: "/actions/commerce/cart/update-cart",
			headers: {
				"X-CSRF-Token": window.csrfTokenValue,
			},
			data: {
				purchasableId: $purchasableId,
				qty: $qty,
			},
		}).done(function (data) {
			// get data for purchasable and update basket summary
			console.log(data);
			if (data.cart) {
				console.log("Success");

				var currency = $miniCartSummary.data("currency");

				$addedToBasket.addClass("d-lg-flex");

				// update added to basket content
				$.each(data.cart.lineItems, function (key, lineItem) {
					if (lineItem.purchasableId == $purchasableId) {
						$name.html(lineItem.description);
						$price.html(
							currency + Number(lineItem.salePrice).toFixed(2)
						);
						// $itemQty.html(lineItem.qty);
						$itemQty.html($qty);

						return false;
					}
				});

				$totalPrice.html(currency + Number(data.cart.total).toFixed(2));
				$totalQty.html(data.cart.totalQty);
				$basketImage.html(
					'<img src="' + $image + '" class="mr-3 rounded">'
				);

				$miniCartSummary.data("has-items", true).addClass("active");
				$headerBasket.data("basket-updated", true);
				$headerBasket.attr("data-qty", data.cart.totalQty);
				if (data.cart.totalQty > 9) {
					$headerBasket.addClass("double-digits");
				} else if ($headerBasket.hasClass("double-digits")) {
					$headerBasket.removeClass("double-digits");
				}

				// update any required product cards
				$this
					.parent()
					.find('[data-id="required-product-message"]')
					.removeClass("d-none");
				
				var itemCount = $this.parents('.related-item-box').find('.count').text();
				$this.parents('.related-item-box').find('.count').text((+$qty)+(+itemCount))

				// var $cardFooter = $target
				// 	.find('[data-required-id="' + $purchasableId + '"]')
				// 	.find(".card-footer");

				// $cardFooter
				// 	.find('[data-id="required-product-message"]')
				// 	.addClass("d-none");
				// $cardFooter.find('[data-id="cart-form"]').removeClass("d-none");

				$this
					.html(
						'<svg width="25" height="25" viewBox="0 0 20 20" fill="none" class="mr-2" xmlns="http://www.w3.org/2000/svg"><path d="M14.4205 6.82693C14.7256 7.13211 14.7256 7.6268 14.4205 7.93182L9.17938 13.1731C8.87421 13.4781 8.37967 13.4781 8.07449 13.1731L5.57953 10.6779C5.27435 10.3729 5.27435 9.87823 5.57953 9.57321C5.88455 9.26804 6.37924 9.26804 6.68427 9.57321L8.62686 11.5158L13.3156 6.82693C13.6208 6.52191 14.1154 6.52191 14.4205 6.82693ZM20 10C20 15.5275 15.5267 20 10 20C4.4725 20 0 15.5267 0 10C0 4.4725 4.47327 0 10 0C15.5275 0 20 4.47327 20 10ZM18.4375 10C18.4375 5.33615 14.6632 1.5625 10 1.5625C5.33615 1.5625 1.5625 5.33676 1.5625 10C1.5625 14.6638 5.33676 18.4375 10 18.4375C14.6638 18.4375 18.4375 14.6632 18.4375 10Z" fill="white"/></svg> Done'
					)
					.addClass("btn-success")
					.removeClass("btn-dark"); 

				setTimeout(() => {
					$('.cart-btn-wrap').addClass('two-btn')
					$this
					.html(
						'<svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2"> <path d="M8.14808 17.8007C8.11007 17.807 8.07229 17.8101 8.03501 17.8101C7.70725 17.8101 7.41797 17.5734 7.3623 17.2394L6.67948 13.1425C6.61748 12.7706 6.86876 12.4187 7.24076 12.3567C7.61275 12.2946 7.96454 12.546 8.02654 12.918L8.70935 17.0149C8.77135 17.3869 8.52008 17.7387 8.14808 17.8007Z" fill="white"/> <path d="M16.2638 17.2393C16.2082 17.5733 15.9189 17.81 15.5911 17.81C15.5539 17.81 15.5161 17.807 15.4781 17.8006C15.1061 17.7386 14.8548 17.3868 14.9168 17.0148L15.5996 12.9179C15.6616 12.546 16.0133 12.2947 16.3854 12.3567C16.7574 12.4187 17.0087 12.7705 16.9467 13.1425L16.2638 17.2393Z" fill="white"/> <path d="M0.866335 6.88477H3.26943L8.52691 0.312916C8.76244 0.0185318 9.19211 -0.0293108 9.48663 0.206305C9.78111 0.441876 9.82886 0.871548 9.59324 1.16602L5.01825 6.88477H18.6555L14.0805 1.16602C13.8449 0.871548 13.8926 0.441831 14.1871 0.206305C14.4816 -0.0293108 14.9113 0.0184863 15.1468 0.312916L20.4043 6.88477H22.8074C23.1845 6.88477 23.4902 7.19049 23.4902 7.56758V10.2988C23.4902 10.6759 23.1845 10.9817 22.8074 10.9817H21.9568L19.367 20.0458C19.2833 20.339 19.0154 20.541 18.7105 20.541H4.96322C4.65837 20.541 4.39043 20.339 4.30667 20.0458L1.71694 10.9817H0.866335C0.489241 10.9817 0.183521 10.6759 0.183521 10.2988V7.56758C0.183521 7.19049 0.489241 6.88477 0.866335 6.88477ZM5.47824 19.1754H18.1955L20.5366 10.9817H3.13715L5.47824 19.1754ZM1.54915 9.61603C3.88824 9.61603 19.9086 9.61603 22.1246 9.61603V8.2504H1.54915V9.61603Z" fill="white"/> <path d="M11.8384 17.8098C11.4613 17.8098 11.1556 17.5041 11.1556 17.127V13.0301C11.1556 12.653 11.4613 12.3473 11.8384 12.3473C12.2155 12.3473 12.5212 12.653 12.5212 13.0301V17.127C12.5212 17.5041 12.2155 17.8098 11.8384 17.8098Z" fill="white"/> </svg> Add to Basket'
					)
					.addClass("btn-dark")
					.removeClass("btn-success"); 
				}, 2000);
			}
		});
	});
	
};

export default func;
